import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { GentlemanJimLogo } from 'src/assets/logos/GentlemanJimLogo';
import { GentleManJimBrandIcon } from 'src/assets/brandIcons/GentleManJimBrandIcon';

export const GentlemanJimMainLogoWrapper = withConfig(theme => styled('div', { label: 'GentlemanJimMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const GentlemanJimMainLogo = styled(GentlemanJimLogo, { label: 'GentlemanJimMainLogo' })`
    height: 24px;
    margin: 0 auto;
    width: 95px;
`;

export const GentleManJimBrandIconWrapper = styled(GentleManJimBrandIcon, { label: 'GentleManJimBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 20px;
    margin: 0 auto;
    width: 20px;
`;
